import type { WebObservability } from "@infinitaslearning/observability-web";
import { createContext, type ReactNode, useContext } from "react";

const ObservabilityContext = createContext<WebObservability | null | undefined>(undefined);

interface Props {
  children: ReactNode;
  apm: WebObservability | null;
}

export function ObservabilityProvider({ children, apm }: Props) {
  return <ObservabilityContext.Provider value={apm}>{children}</ObservabilityContext.Provider>;
}

export function useObservability(): WebObservability | null {
  const value = useContext(ObservabilityContext);
  if (value === undefined) {
    throw new Error("useObservability must be used within an ObservabilityProvider");
  }
  return value;
}
